<template>
    <div v-if="loaded">
        <el-table
            :data="getFilteredData"
            style="width: 100%"
            :default-sort = "{prop: sort, order: order}"
        >
            <el-table-column  v-for="col in tableHeaders"
                              :key="col.key"
                              :prop="col.prop"
                              :label="col.label"
                              sortable
                              :formatter="formatter">
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
import axios from '@/services/axios.js'
import { getTableHeaders, getHeadersWithAccessToken } from '../functions.js'

export default {
    props: ['title', 'endpoint', 'sort', 'order'],
    data () {
        return {
            tableData: [],
            tableHeaders: [],
            loaded: false
        }
    },
    computed: {
        getFilteredData () {
            return this.tableData
        }
    },
    methods: {
        draw () {
            this.loaded = false
            axios.post(((this.$store.state.general.devMode === true) ? process.env.VUE_APP_DATA_API_BASE_URL_DEV : process.env.VUE_APP_DATA_API_BASE_URL) + '/at' + this.$props.endpoint, {
                'format': 'aod',
                'store_id': this.endpoint !== '/performance/contracts/active' ? this.$store.getters['graphFilter/getStoreIds'] : this.$store.getters['graphFilter/getZoomedinStores'],
                'period_type': this.$store.getters['graphFilter/getPeriod'],
                'period_amount': this.$store.getters['graphFilter/getNumberOfPeriods'],
                'days_back': 0
            }, { headers: getHeadersWithAccessToken() })
                .then(response => {
                    this.tableData = response.data.data
                    this.tableHeaders = getTableHeaders(response.data.columns)
                    this.loaded = true
                })
                .catch(error => {
                    console.log(error)
                })
        },
        formatter (row, column) {
            if (column.property === 'Rate' || column.property === 'Costs' || column.property === 'Hours rate') {
                return '€' + row[column.property].toLocaleString('en-EN')
            } else if (column.property.includes('ID')) {
                return row[column.property]
            } else {
                return row[column.property].toLocaleString('en-EN')
            }
        }
    },
    mounted () {
        this.draw()
    }
}
</script>

<style langs="scss">
    .highlight-row {
        background-color: #f5f7fa !important;
    }
</style>
